import { render, staticRenderFns } from "./InterestChangeActivationType.vue?vue&type=template&id=60649340&"
import script from "./InterestChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./InterestChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports